// Workspace-local media tokens (merged on top of the inherited breakpoints).
//
// Touch-capability tokens for the iPad pass. They MUST be registered here so a
// component key like '@coarse' compiles to a real @media query — an
// UNregistered '@name' silently compiles to a bogus [data-theme="name"]
// selector instead (that's how @dark/@light work). Value = the query body only,
// no @media wrapper (matches the default token format, e.g. tv: 'min-width: 2780px').
//
//   '@coarse': { … }  → touch-primary devices (iPad, phones, touchscreens)
//   '@touch':  { … }  → touch AND no true hover (excludes trackpad hybrids)
//
// tabletSOnly / tabletMOnly / desktopSOnly — MUTUALLY EXCLUSIVE responsive
// ranges (2026-08-02,
// phone "one deck" header merge). The base tabletS/tabletM tokens are plain
// max-width, so a viewport ≤768px matches @mobileL AND @tabletS AND @tabletM
// simultaneously. That's fine when a component's blocks don't disagree — but
// where a @mobileL block overrides the SAME property a @tabletS/@tabletM
// block also sets on the SAME component (AppHeader's HeaderLeft/HeaderTabs/
// HeaderRight), the one that wins is decided by the ATOMIC CSS ENGINE'S
// GLOBAL class-insertion order (first-encountered-anywhere-in-the-app order,
// not JS object key order, not "narrower breakpoint should win" logic) —
// verified live: HeaderTabs' @tabletS `left: calc(--hdr-left-w …)` was
// winning over its own @mobileL `left: auto` at 390px, because that calc()
// value's class had already been registered earlier by another component.
// tabletSOnly/tabletMOnly close the gap at its root: a genuinely
// non-overlapping range can never lose a cascade tie to @mobileL, because it
// never matches in the same viewport at all.
export default {
  reducedMotion: '(prefers-reduced-motion: reduce)',
  coarse: '(pointer: coarse)',
  touch: '(hover: none) and (pointer: coarse)',
  calendarActionsCompact: '(max-width: 847px)',
  calendarHeaderWide: '(min-width: 1441px)',
  tabletSOnly: '(max-width: 1024px) and (min-width: 769px)',
  tabletMOnly: '(max-width: 1280px) and (min-width: 769px)',
  desktopSOnly: '(max-width: 1440px) and (min-width: 1281px)',
  // ABOVE THE PHONE STEP — the exact complement of the brand's `mobileL`
  // (max-width: 768px), in range syntax so no fractional width falls between
  // the two. The brand's own `mobileL<` is min-width: 768px, which OVERLAPS
  // `mobileL` at exactly 768 (iPad portrait): a pair of rules keyed on both
  // would both match there. Used by the home top (components/HomeAppStrip.js):
  // the Dock steps aside for the Rail only above the phone step, as ONE rule
  // inside this media block — never a base rule plus a phone override, whose
  // winner the atomic engine's sheet order would decide.
  aboveMobileL: '(width > 768px)',
  // BELOW THE SPLIT FLOOR — the viewport where the shell refuses a second
  // PageSlot pane: `width < SPLIT_MIN_WIDTH_PX` (functions/searchApps.js,
  // 1024), the exact complement of `splitFitsWidth`. The pane header's Split
  // button hides here (canvas/components/PageSlot.js SplitBtn), so the button
  // is shown exactly where a split can open. Range syntax, so 1024 itself —
  // where a split fits — never matches; the brand's `tabletS` (max-width:
  // 1024px) would hide the button at a width that splits.
  // __tests__/pageSlotSplitFloor.test.js locks this number to the constant.
  splitBelowFloor: '(width < 1024px)'
}
